import { TaxSettingsInterface } from '../interfaces/tax-settings.interface';

/**
 * The keys that make up a {@link TaxSettingsInterface}. Used to snapshot ONLY the
 * tax-related configuration out of the broader platform settings blob (which also
 * holds notifications, etc.) so that unrelated config never leaks
 * into places typed as tax settings.
 */
export const TAX_SETTINGS_KEYS: (keyof TaxSettingsInterface)[] = [
  'isTaxIncluded',
  'defaultTaxRateType',
  'standardTaxRate',
  'exemptTaxRate',
  'zeroTaxRate',
  'reducedTaxRate1',
  'reducedTaxRate2',
  'reducedTaxRate3',
  'reverseChargeTaxRate',
  'standardTaxRateLabel',
  'exemptTaxRateLabel',
  'zeroTaxRateLabel',
  'reducedTaxRate1Label',
  'reducedTaxRate2Label',
  'reducedTaxRate3Label',
  'reverseChargeTaxRateLabel',
];

/**
 * Returns a new object containing only the tax-related keys from the given source.
 * Keys that are `undefined` on the source are omitted. Returns `null` when there is
 * nothing to snapshot.
 */
export function pickTaxSettings(
  source: TaxSettingsInterface | null | undefined,
): TaxSettingsInterface | null {
  if (!source) {
    return null;
  }

  const taxSettings: TaxSettingsInterface = {};
  for (const key of TAX_SETTINGS_KEYS) {
    if (source[key] !== undefined) {
      taxSettings[key] = source[key] as never;
    }
  }

  return taxSettings;
}
